// Assessment Template Types
export interface AssessmentTemplate {
  id: number
  uuid: string
  title: string
  subtitle: string
  description: string
  icon: string
  color: string
  category: string
  questions: string[]
  status: 'ACTIVE' | 'INACTIVE'
}

export interface AssessmentTemplateResponse {
  success: boolean
  count: number
  data: AssessmentTemplate[]
}

// Assessment Types
export interface Assessment {
  id: number
  uuid: string
  assessmentId: string
  title: string
  subtitle: string
  description: string
  icon: string
  color: string
  category: string
  status: 'ACTIVE' | 'INACTIVE'
  shareableLink?: string
  createdAt?: string
  updatedAt?: string
}

// Question Types
export type QuestionType = 'MCQ' | 'SINGLE' | 'MULTIPLE' | 'DESCRIPTIVE'

export interface Question {
  id?: number
  uuid?: string
  assessmentId: string
  order: number
  question: string
  type: QuestionType
  options: string[]
  correctAnswers?: number[] // Indices of correct options (for MCQ/SINGLE/MULTIPLE)
  status: 'ACTIVE' | 'INACTIVE'
}

export interface QuestionResponse {
  id: number
  uuid: string
  assessmentId: string
  order: number
  question: string
  type: QuestionType
  options: string[]
  correctAnswers?: number[] // Indices of correct options (for MCQ/SINGLE/MULTIPLE)
  status: 'ACTIVE' | 'INACTIVE'
}

// Static Likert scale options for all assessment questions
export const STATIC_LIKERT_OPTIONS = [
  '1 - Strongly Disagree',
  '2 - Disagree',
  '3 - Neutral',
  '4 - Agree',
  '5 - Strongly Agree'
]

// Reorder Types
export interface QuestionOrder {
  questionId: number
  order: number
}

export interface ReorderRequest {
  orders: QuestionOrder[]
}
